import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-xl mx-auto" id="categories">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border-2 border-background-200 rounded-xl text-sm text-foreground-700 hover:border-accent-400 transition-colors cursor-pointer"
      >
        <span className="font-medium">{open ? 'Select a category...' : 'Select Category'}</span>
        <div className="w-5 h-5 flex items-center justify-center">
          {open ? (
            <i className="ri-arrow-up-s-line text-base text-foreground-500"></i>
          ) : (
            <i className="ri-arrow-down-s-line text-base text-foreground-500"></i>
          )}
        </div>
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl overflow-hidden z-30 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className={`${cat.icon} text-base text-accent-500`}></i>
                </div>
                <span>{cat.name}</span>
              </div>
              <span className="text-xs text-foreground-400">{cat.itemCount} items</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}